import React, { useEffect, useState } from "react";
import { heroSlides } from "../mock";
import { Play, Info, ChevronLeft, ChevronRight } from "lucide-react";

export default function HeroSection({ onPlay }) {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setActive((v) => (v + 1) % heroSlides.length), 5000);
    return () => clearInterval(id);
  }, []);

  const next = () => setActive((v) => (v + 1) % heroSlides.length);
  const prev = () => setActive((v) => (v - 1 + heroSlides.length) % heroSlides.length);

  const current = heroSlides[active];

  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0 -z-10"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(10,10,12,0.55) 0%, rgba(10,10,12,0.95) 90%), url(${current.image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(20px)",
          transform: "scale(1.1)",
        }}
      />
      <div className="max-w-[1500px] mx-auto px-6 py-12 md:py-20 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-600/15 border border-red-600/30 text-red-500 text-xs font-semibold mb-4">
            EM DESTAQUE • {current.subtitle}
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight leading-tight">
            Desbloqueie novos recursos com o <span className="text-cyan-400">app UniPlay UHD</span>
          </h1>
          <p className="mt-4 text-white/70 max-w-xl">{current.description}</p>
          <div className="mt-8 flex items-center gap-3">
            <button
              onClick={() => onPlay(current)}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-red-600 to-red-700 text-white font-semibold shadow-lg shadow-red-600/30 hover:shadow-red-600/50 hover:brightness-110 transition"
            >
              <Play className="w-4 h-4 fill-white" /> ASSISTIR AGORA
            </button>
            <button className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/8 hover:bg-white/12 text-white font-semibold transition border border-white/10">
              <Info className="w-4 h-4" /> Mais Info
            </button>
          </div>
          <div className="mt-8 flex items-center gap-2 text-xs text-white/50">
            {heroSlides.map((s, i) => (
              <button
                key={s.id}
                onClick={() => setActive(i)}
                className={`h-1 rounded-full transition-all ${i === active ? "bg-red-600 w-10" : "bg-white/20 w-5 hover:bg-white/40"}`}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="relative flex justify-center md:justify-end">
          <div className="hero-stack">
            {heroSlides.map((s, i) => {
              const offset = (i - active + heroSlides.length) % heroSlides.length;
              const z = heroSlides.length - offset;
              const visible = offset < 4;
              const styles = {
                transform: `translate(${offset * 26}px, ${offset * -22}px) rotate(${offset * 4}deg) scale(${1 - offset * 0.05})`,
                opacity: visible ? 1 - offset * 0.18 : 0,
                zIndex: z,
              };
              return (
                <div key={s.id} className="hero-card" style={styles}>
                  <img src={s.image} alt={s.title} />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <p className="text-white/70 text-xs uppercase tracking-widest">{s.subtitle}</p>
                    <h3 className="text-white font-extrabold text-2xl mt-1">{s.title}</h3>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="absolute -bottom-2 right-0 flex gap-2">
            <button onClick={prev} className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition flex items-center justify-center" aria-label="Anterior">
              <ChevronLeft className="w-5 h-5 text-white" />
            </button>
            <button onClick={next} className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition flex items-center justify-center" aria-label="Próximo">
              <ChevronRight className="w-5 h-5 text-white" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
